import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
} from "@mui/material";
import {
  FC,
  MouseEvent,
  memo,
  useCallback,
  useState,
} from "react";

type InputAction = {
  disabled?: boolean;
  label: string;
  onClick: () => void;
};

export const InputActionMenu: FC<{
  actions: InputAction[];
  label: string;
}> = memo(({ actions, label }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = !!anchorEl;

  const handleOpen = useCallback((event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleActionClick = useCallback(
    (action: InputAction) => {
      action.onClick();
      handleClose();
    },
    [handleClose],
  );

  return (
    <>
      <InputAdornment position='end'>
        <IconButton
          aria-label={`${label} actions`}
          edge='end'
          size='small'
          onClick={handleOpen}
        >
          <MoreVertIcon fontSize='small' />
        </IconButton>
      </InputAdornment>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {actions.map((action) => (
          <MenuItem
            key={action.label}
            dense
            disabled={action.disabled}
            onClick={() => handleActionClick(action)}
          >
            {action.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
});
